import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SuiContainer } from '@splashthat/sui';
import ColorPickerEditor from 'common/components/ColorPicker';
import BorderEditor from 'common/components/BorderPicker';
import { getColors } from 'common/entities/color/selectors';
import {
    setFormSecondaryButtonBorderColorDefault,
    setFormSecondaryButtonBorderColorHover,
    setFormSecondaryButtonBorderColorFocus,
    setFormSecondaryButtonBorderRadius,
    setFormSecondaryButtonBorderSizeTop,
    setFormSecondaryButtonBorderSizeBottom,
    setFormSecondaryButtonBorderSizeRight,
    setFormSecondaryButtonBorderSizeLeft,
    setAllFormSecondaryButtonBorderSizes,
} from 'common/entities/form/styleConfiguration/actions';
import { getFormSecondaryButtonBorderStyles } from 'common/entities/form/styleConfiguration/selectors';

import {
    COLOR_PICKER_DEFAULT,
    COLOR_PICKER_HOVER,
    BUTTON_LABEL_TEXT,
    COLOR_PICKER_FOCUS,
} from '../../../../constants/formStyleLabels';
import { getFormId } from '../../../../selectors';
import { SECONDARY_BUTTON_QA } from '../../../../utils/qaIdConstants';

const SecondaryButtonBorderPanel = () => {
    const dispatch = useDispatch();
    const formId = useSelector(getFormId);
    const colorList = useSelector(getColors);
    const {
        colors,
        radius: borderRadius,
        ...borderWidths
    } = useSelector((state) => getFormSecondaryButtonBorderStyles(state, formId));
    const { default: defaultColor, hover: hoverColor, focus: focusColor } = colors;

    return (
        <SuiContainer className={'BorderColorPicker'} data-qa={`${SECONDARY_BUTTON_QA}--label`}>
            <BorderEditor
                borderWidths={borderWidths}
                onBorderWidthsChanged={(widths) => dispatch(setAllFormSecondaryButtonBorderSizes(formId, widths))}
                borderRadius={borderRadius}
                onBorderRadiusChanged={(radius) => dispatch(setFormSecondaryButtonBorderRadius(formId, radius))}
                onChangeTopBorderWidth={(width) => dispatch(setFormSecondaryButtonBorderSizeTop(formId, width))}
                onChangeBottomBorderWidth={(width) => dispatch(setFormSecondaryButtonBorderSizeBottom(formId, width))}
                onChangeRightBorderWidth={(width) => dispatch(setFormSecondaryButtonBorderSizeRight(formId, width))}
                onChangeLeftBorderWidth={(width) => dispatch(setFormSecondaryButtonBorderSizeLeft(formId, width))}
                borderOptionsQa={`${SECONDARY_BUTTON_QA}--borderOptions`}
                borderDropdownQa={`${SECONDARY_BUTTON_QA}--borderDropdown`}
                componentLabel={BUTTON_LABEL_TEXT}
            />
            <ColorPickerEditor
                colorList={colorList}
                firstColor={defaultColor}
                firstColorLabel={COLOR_PICKER_DEFAULT}
                changeFirstColor={(id) => dispatch(setFormSecondaryButtonBorderColorDefault(formId, id))}
                qaId={SECONDARY_BUTTON_QA}
            />
            <ColorPickerEditor
                colorList={colorList}
                firstColor={hoverColor}
                firstColorLabel={COLOR_PICKER_HOVER}
                changeFirstColor={(id) => dispatch(setFormSecondaryButtonBorderColorHover(formId, id))}
                secondColor={focusColor}
                secondColorLabel={COLOR_PICKER_FOCUS}
                changeSecondColor={(id) => dispatch(setFormSecondaryButtonBorderColorFocus(formId, id))}
                qaId={`${SECONDARY_BUTTON_QA}--hoverFocus`}
            />
        </SuiContainer>
    );
};

export default SecondaryButtonBorderPanel;
